import React, { useState } from 'react';
import { Table, Checkbox, Button, Modal } from 'antd';
import './AttributeTable.scss';

interface AttributeTableProps {
  data: any[];
  columns: string[];
  onApply: (selected: string[]) => void;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  selectedColumns: any[];
  setSelectedColumns: (value: any) => void;
}

const AttributeTable: React.FC<AttributeTableProps> = ({
  data,
  columns,
  onApply,
  isModalVisible,
  setIsModalVisible,
  selectedColumns,
  setSelectedColumns,
}) => {
  const [isAllSelected, setIsAllSelected] = useState(false);

  // Generate dynamic columns for the table
  const tableColumns = columns?.map((col) => ({
    title: (
      <Checkbox checked={selectedColumns?.includes(col)} onChange={(e) => handleColumnSelect(e, col)}>
        {col}
      </Checkbox>
    ),
    dataIndex: col,
    key: col,
    width: 150,
  }));

  const handleColumnSelect = (e: any, column: string) => {
    setSelectedColumns((prev: any) =>
      e.target?.checked ? [...(Array.isArray(prev) ? prev : []), column] : (Array.isArray(prev) ? prev : []).filter((col: any) => col !== column),
    );
  };

  const handleSelectAll = (checked: boolean) => {
    setIsAllSelected(checked);
    setSelectedColumns(checked ? columns : []);
  };

  const handleApply = () => {
    onApply(selectedColumns);
    setIsModalVisible(false);
  };

  const transformedData = data.map((item) => ({
    ...item.properties,
    id: item.id,
  }));

  return (
    <>
      <Modal
        title="Filter by Field"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        width="80%"
        centered
        className="attribute-table-modal"
        footer={
          <Button type="primary" onClick={handleApply} className="attribute-table-modal__apply-btn">
            Apply
          </Button>
        }
      >
        <div className="checkbox-controls">
          <Checkbox checked={isAllSelected} onChange={(e) => handleSelectAll(e.target?.checked)}>
            Select All
          </Checkbox>
          <Checkbox checked={!isAllSelected && selectedColumns?.length === 0} onChange={(e) => handleSelectAll(!e.target?.checked)}>
            Unselect All
          </Checkbox>
        </div>

        <Table
          className="custom-table bordered-table"
          dataSource={transformedData}
          columns={tableColumns}
          pagination={false}
          scroll={{ x: 'max-content', y: 300 }}
          rowKey={(_, index) => index!.toString()}
        />
      </Modal>
    </>
  );
};

export default AttributeTable;
